import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';
import { Affiliate, AffiliatePayload } from './affiliate.types';

export interface ResetPasswordPayload {
  affiliateId: string;
}

export interface UpdateStatusPayload {
  affiliateId: string;
  status: string;
}

const resetAffiliatePassword = (client: AxiosInstance) => async (payload: ResetPasswordPayload) => {
  return (await client.post<{ message: string; data: Affiliate }>(API_ROUTES.RESET_AFFILIATE_PASSWORD, payload)).data;
};

const updateAffiliateStatus = (client: AxiosInstance) => async (payload: UpdateStatusPayload) => {
  return (await client.post<{ message: string; data: Affiliate }>(API_ROUTES.UPDATE_AFFILIATE_STATUS, payload)).data;
};

const updateAffiliateDetails = (client: AxiosInstance) => async (payload: AffiliatePayload) => {
  return (await client.post<{ message: string; data: unknown }>(API_ROUTES.UPDATE_AFFILIATE_DETAILS, payload)).data;
};

export const affiliateMutations = {
  resetAffiliatePassword,
  updateAffiliateStatus,
  updateAffiliateDetails,
};
